import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { Link } from "gatsby";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Cúram offers different Learning Paths as a way for you to learn how to perform a certain job role, or acquire the knowledge for a particular skillset.`}</p>
    <p>{`Our Learning Paths are comprised of courses (listed on the `}<Link to="/spm/education/training_courses" mdxType="Link">{`Available Courses`}</Link>{` page) that you take in a specific order, so that you build up the knowledge in an appropriate order and don’t miss out on something that underpins a more advanced topic.`}</p>
    <p>{`To review full details of the paths and courses contained, please download `}<a parentName="p" {...{
        "href": "/wh-support-docs/pdf/education/C%C3%BAram_TrainingPaths_Courses.pdf"
      }}>{`Cúram_TrainingPaths_Courses.pdf`}</a></p>
    <h2>{`Developer Learning Paths`}</h2>
    <h3>{`Technical Fundamentals 8.X`}</h3>
    <ol>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur087-introduction-to-the-merative-curam-platform-8.x:-functional-overview" mdxType="Link">
  Introduction to the Merative Cúram Platform 8.X: Functional Overview
        </Link>
      </li>
      <li parentName="ol">
        <Link to="https://www.merative.com/curam" mdxType="Link">
  Social Program Management Success Stories
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur089-merative-curam-8.x-technical-overview" mdxType="Link">
  Merative Cúram 8.X Technical Overview
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur093-(dl41001g)-merative-spm-on-kubernetes-for-business-consultants" mdxType="Link">
  Cúram on Kubernetes for Business Consultants
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur110-introduction-to-curam-evidence" mdxType="Link">
  Introduction to Cúram Evidence
        </Link>
      </li>
    </ol>
    <h3>{`V8.X Developer Certification`}</h3>
    <ol>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur090-merative-curam-for-developers-(ade)-8.x" mdxType="Link">
  Merative Cúram for Developer (ADE) 8.X
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur091-merative-curam-for-developers-(customization)-8.x" mdxType="Link">
  Merative Cúram for Developers (Customization) 8.X
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur092-merative-curam-development-environment-8.x-for-developers:-sandbox" mdxType="Link">
  Merative Cúram Development Environment 8.X: Sandbox
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/ade_certification_v8" mdxType="Link">
  Cúram V8.X ADE Accreditation
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/dev_certification_v8" mdxType="Link">
  Cúram V8.X Customization Certification
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/booking_tests" mdxType="Link">
  Booking Cúram 8.X Certification
        </Link>
      </li>
    </ol>
    <h3>{`Specialized Developer - Citizen Engagement (Backend)`}</h3>
    <ol>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur104-merative-curam-citizen-engagement-server-side-for-developers" mdxType="Link">
  Merative Cúram Citizen Engagement Server-Side for Developers
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur082-(9d82g)-ibm-curam-spm-intelligent-evidence-gathering-(ieg)-for-developers-7.x" mdxType="Link">
  Merative SPM Intelligent Evidence Gathering (IEG) for Developers
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/learning_paths#specialized-developer-rules-and-evidence" mdxType="Link">
  Specialized Developer - Rules and Evidence (below)
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur068-(9d68g)-merative-curam-developing-rest-apis" mdxType="Link">
  Merative Cúram - Developing REST APIs
        </Link>
      </li>
    </ol>
    <h3>{`Citizen Engagement / Universal Access (Front End)`}</h3>
    <ol>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur105-merative-curam-ghhs-web-design-system-for-designers" mdxType="Link">
  Merative Cúram GHHS Web Design System for Designers
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur080-(9d80g)-ibm-spm-design-system-for-developers" mdxType="Link">
  Merative SPM Design System for Developers
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur081-(9d81g)-ibm-universal-access-for-developers-(responsive-web-application)" mdxType="Link">
  Merative SPM Universal Access for Developers (Responsive Web Application)
        </Link>
      </li>
    </ol>
    <h3>{`Specialized Developer - Rules and Evidence`}</h3>
    <ol>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur110-introduction-to-curam-evidence" mdxType="Link">
  Merative Cúram Introduction to Evidence
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur111-merative-curam-evidence-for-developers" mdxType="Link">
  Merative Cúram Evidence for Developers
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur099-merative-curam-express-rules-for-developers-v8.x" mdxType="Link">
  Merative Cúram Express Rules for Developers 8.X
        </Link>
      </li>
    </ol>
    <h2>{`Business User Learning Paths`}</h2>
    <h3>{`Cúram Functional User (Non-Certified) 8.X`}</h3>
    <ol>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur087-introduction-to-the-merative-curam-platform-8.x:-functional-overview" mdxType="Link">
  Introduction to Merative Cúram Platform 8.X: Functional Overview
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur097-merative-curam-development-environment-8.x-for-bas:-sandbox" mdxType="Link">
  (optional) Cúram Development Environment 8.X for BAs: Sandbox
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur102-fundamentals-of-curam-financial-management" mdxType="Link">
  Fundamentals of Cúram Financial Management
        </Link>
      </li>
      <li parentName="ol">
        <Link to="https://www.merative.com/curam" mdxType="Link">
  Social Program Management Success Stories
        </Link>
      </li>
    </ol>
    <h3>{`Cúram Business Analyst 8.X (Certified)`}</h3>
    <ol>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur088-fundamentals-of-the-merative-curam-platform-for-business-analysts-8.x" mdxType="Link">
  Fundamentals of the Merative Cúram Platform for Business Analyst 8.X
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/ba_certification_v8" mdxType="Link">
  Business Certification Advice
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur097-merative-curam-development-environment-8.x-for-bas:-sandbox" mdxType="Link">
  (optional) Cúram Development Environment 8.X for BAs: Sandbox
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/booking_tests" mdxType="Link">
  Cúram 8.X Business Analyst Certification
        </Link>
      </li>
    </ol>
    <h3>{`Specialized Cúram Business Analyst`}</h3>
    <ol>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur105-merative-curam-ghhs-web-design-system-for-designers" mdxType="Link">
  Merative Cúram GHHS Web Design System for Designers
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur110-introduction-to-curam-evidence" mdxType="Link">
  Introduction to Cúram Evidence
        </Link>
      </li>
      <li parentName="ol">
        <Link to="/spm/education/training_courses#cur093-(dl41001g)-curam-on-kubernetes-for-business-consultants" mdxType="Link">
  Cúram on Kubernetes for Business Consultants
        </Link>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      